import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useStore } from '../../../app/stores/store';
import './dashboard.css';
import ApproveModal from './../../../app/common/modals/ApproveModal';
import ReportsModal from '../../TableReports/ReportsModal';
import DynamicTableComponent from '../../DynamicTable/DynamicTableComponent';
import { v4 as uuid } from 'uuid';
import { Activity } from '../../../app/models/activity';
import _ from 'lodash';

function DashboardCreateOrderTable() {
  const { activityStore, dashboardStore, commonStore } = useStore();
  const { userReadableDateFormat } = commonStore;
  const { activitiesByDate, loadCRPagination, loadCRLoading } = activityStore;
  const [pageNumber, setPageNumber] = useState(
    dashboardStore.dashboard.setCRTablePageNumber,
  );
  useEffect(() => {
    if (dashboardStore.dashboard.setCRTablePageNumber === 1) {
      setPageNumber(dashboardStore.dashboard.setCRTablePageNumber);
    }
  }, [dashboardStore.dashboard.setCRTablePageNumber]);

  useEffect(() => {
    loadCRPagination(1);
    dashboardStore.createOrderCount();
    // eslint-disable-next-line
  }, []);

  const tableData: Activity[] = [];

  activitiesByDate.forEach((a) => {
    delete a?.isMaster;
    // eslint-disable-next-line
    delete a?.sections_Multiple_From;
    delete a?.sections_From;
    tableData?.push({
      ...a,
      movementdate: userReadableDateFormat(a.movementdate),
      movement_Time: userReadableDateFormat(a.movement_Time),
      maintenance: userReadableDateFormat(a.maintenance),
      receivingdate: userReadableDateFormat(a.receivingdate),
      status_Time: userReadableDateFormat(a.status_Time),
      itemCreatedAt: userReadableDateFormat(a.itemCreatedAt),
    });
  });

  const removeCol =
    'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,typeid,thumbnail,preview,proxy,global_positioning_system,isHost,elementtypeid,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost,clearedon';
  const assettable = JSON.parse(JSON.stringify(tableData));
  assettable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

  const paginateFunction = (e: number) => {
    if (
      !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
      Object.values(dashboardStore.dashboard.searchfilterparams).every(
        (o) => o !== '',
      ) &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      activityStore.searchListCR(
        e,
        dashboardStore.dashboard.searchfilterparams,
      );
    } else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      activityStore.sortListCR(
        dashboardStore.dashboard.orderName,
        dashboardStore.dashboard.orderData,
        e,
      ); //api call
    } else {
      loadCRPagination(e);
    }
    dashboardStore.setCRTablePageNumFunc(e);
    setPageNumber(e);
  };
  const searchFunction = (column: any, order: any) => {
    console.log(order, column);
  };
  //  if (!loadCRPagination) return <LoadingComponent />;

  // const assetTableData=
  return (
    <div>
      {dashboardStore.dashboard.DenialModal === true ? (
        <ApproveModal />
      ) : dashboardStore.dashboard.reportsConfiguration === true ? (
        <ReportsModal
          toggleProps={dashboardStore.dashboard.tableconfigurationClicked}
        />
      ) : null}

      <DynamicTableComponent
        key={uuid()}
        data={assettable}
        name={'CreateOrderTable'}
        actiontype={''}
        pageFunc={paginateFunction}
        pageNumData={pageNumber}
        searchFuncData={searchFunction}
        loading={loadCRLoading}
      />
    </div>
  );
}
export default observer(DashboardCreateOrderTable);
